function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import TextInput from '../text';
import { pickValidValues } from '../../../helpers/components-helpers';

class PhoneInput extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "_beforeMaskedValueChange", (newState, oldState) => {
      if (!newState.value) {
        return newState;
      }

      var {
        value: oldValue,
        selection: oldSelection
      } = oldState;
      var {
        value: newValue,
        selection: newSelection
      } = newState;
      var isAutoFillLength = oldValue && newValue && oldValue.length === 14 && newValue.length === 10;
      var isNewSelectionAutofill = newSelection && newSelection.start === 10 && newSelection.end === 10;
      var isOldSelectionAutofill = oldSelection && oldSelection.start === 14 && oldSelection.end === 14;

      if (isAutoFillLength && isOldSelectionAutofill && isNewSelectionAutofill) {
        return oldState;
      }

      return newState;
    });
  }

  _modifyWithDefaultOptions() {
    var {
      options
    } = this.props;
    var optionsWithValidValue = pickValidValues(options);
    return _objectSpread(_objectSpread({
      autoComplete: 'tel'
    }, this.props), {}, {
      options: Object.assign({
        pattern: '^\\d{10}$',
        mask: '(999) 999-9999',
        returnUnmaskedValue: true
      }, optionsWithValidValue)
    });
  }

  render() {
    var modifiedProps = this._modifyWithDefaultOptions();

    return /*#__PURE__*/React.createElement(TextInput, _extends({}, modifiedProps, {
      beforeMaskedValueChange: this._beforeMaskedValueChange
    }));
  }

}

_defineProperty(PhoneInput, "defaultProps", {
  options: {},
  type: 'tel'
});

export default PhoneInput;